// extracted by mini-css-extract-plugin
export default {"container":"Login_container__Icwpx","form-container":"Login_form-container__5PMmG","popup":"Login_popup__+lCk9","popup-text":"Login_popup-text__HSbCY"};